import { useState, useEffect } from "react";
import {
  VStack,
  Flex,
  Input,
  FormLabel,
  FormControl,
  Button,
  Heading,
} from "@chakra-ui/react";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  startAfter,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { db } from "config/firebase";
import Card from "components/Cards/Restaurante";
import Sidebar from "components/layouts/Sidebar";
import { useNavigate } from "react-router-dom";

const ViviendasList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [lastDoc, setLastDoc] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchData = async () => {
    const docRef = collection(db, "restaurantes");
    let q = query(docRef, orderBy("name"), limit(5));
    if (searchTerm) {
      q = query(
        docRef,
        orderBy("name"),
        where("name", ">=", searchTerm),
        where("name", "<=", searchTerm + "\uf8ff")
      );
    }
    const data = await getDocs(q);
    const dataArray = [];
    data.forEach((doc) => {
      dataArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setData(dataArray);
    setLastDoc(data.docs[data.docs.length - 1]);
  };

  const fetchMoreData = async () => {
    const docRef = collection(db, "restaurantes");
    let q = query(
      docRef,
      orderBy("name"),
      where("name", ">=", searchTerm),
      where("name", "<=", searchTerm + "\uf8ff"),
      startAfter(lastDoc),
      limit(5)
    );
    const newData = await getDocs(q);
    const dataArray = [];
    newData.forEach((doc) => {
      dataArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setData([...data, ...dataArray]);
    setLastDoc(newData.docs[newData.docs.length - 1]);
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm]);

  const handleLoadMore = () => {
    fetchMoreData();
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleToggleUser = async (id, isActive) => {
    try {
      const docRef = doc(db, "restaurantes", id);
      await updateDoc(docRef, {
        isActive: !isActive,
      });
      setData(
        data.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              isActive: !isActive,
            };
          }
          return item;
        })
      );
    } catch (error) {
      console.error("Error toggling item: ", error);
    }
  };

  const handleRemoveUser = async (id) => {
    try {
      const docRef = doc(db, "restaurantes", id);
      await deleteDoc(docRef);
      setData(data.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Error removing item: ", error);
    }
  };

  const handleCreate = () => {
    navigate(`/restaurantes/add`);
  };

  return (
    <Sidebar>
      <FormControl mb="4">
        <Flex justify="space-between" align="center" mb={10}>
          <Heading size="md">Restaurantes</Heading>
          <Button colorScheme="brand" onClick={handleCreate}>
            Crear restaurante
          </Button>
        </Flex>
        <Input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Filtrar por nombre"
        />
      </FormControl>
      <VStack spacing={4}>
        {data.map((item) => (
          <Card
            key={item.id}
            item={item}
            handleToggleUser={handleToggleUser}
            handleRemoveUser={handleRemoveUser}
          />
        ))}
        {lastDoc && <Button onClick={handleLoadMore}>Cargar más</Button>}
      </VStack>
    </Sidebar>
  );
};

export default ViviendasList;
